import Text from 'components/Text/Text';
import React, { useCallback } from 'react';
import Pop from 'components/Popover/Pop';
import style from './TerminalsList.module.scss';

interface ITerminalsList {
	data: string[];
}

const TerminalsList: React.FC<ITerminalsList> = ({ data }) => {
	const TerminalsContent = useCallback(() => {
		return (
			<div className={style.container}>
				{data.map((el) => (
					<Text key={el} className={style.item} translationKey={el} size="s" />
				))}
			</div>
		);
	}, [data]);

	return (
		<>
			{data.length > 1 ? (
				<Pop placement="bottomLeft" content={<TerminalsContent />} trigger="click">
					<div className={style.wrapper}>
						<Text translationKey={data[0]} asFragment={true} />
						<span className={style.showListBtn}>&middot;&middot;&middot;</span>
					</div>
				</Pop>
			) : (
				<Text translationKey={data.length ? data[0] : '-'} withTooltip={true} />
			)}
		</>
	);
};

export default React.memo(TerminalsList);
